module.exports = __webpack_public_path__ + "img/daitongguo.a8d49fca.png";